import { render, staticRenderFns } from "./planeOfFire.vue?vue&type=template&id=a939551a&"
import script from "./planeOfFire.vue?vue&type=script&lang=js&"
export * from "./planeOfFire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports